module.exports = __webpack_public_path__ + "img/blueBox.6088b6ff.png";